// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Iceland from '../_raw/flag/icon_flag_iceland.png';

export default () => <img src={Iceland} alt="Iceland" />;
